import { render, staticRenderFns } from "./admin-home.vue?vue&type=template&id=d779059a&"
import script from "./admin-home.vue?vue&type=script&lang=js&"
export * from "./admin-home.vue?vue&type=script&lang=js&"
import style0 from "./admin-home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports